export default __webpack_public_path__ + "static/media/projects.3e14db88.jpg";